module.exports = __webpack_public_path__ + "static/media/logo.fec5d6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 876
// module chunks = 0